<template>
  <div class="profile-page">
    <div class="position-relative">
      <section class="section-profile-cover section-shaped my-0">
        <div class="shape shape-style-1 shape-primary shape-skew alpha-4">
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
        </div>
        <div class="container shape-container d-flex">
          <div class="col px-0">
            <div class="row justify-content-center text-center">
              <div class="col-lg-9">
                <h2 class="text-center text-white">{{translate(getLanguage(), "Seu Perfil")}}</h2>
                <p class="text-center text-white">{{translate(getLanguage(), "Compartilhar mais informações nos ajuda a achar a oportunidade certa pra você")}}.</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
    <section class="section section-skew">
      <div class="container">
        <card shadow class="card-profile mt--300" no-body>
          <div class="px-4">
            <div class="row justify-content-center">
              <div class="col-lg-3 order-lg-2">
                <div class="text-center pt-100">
                    <h3>
                      {{name}}
                    </h3>
                </div>
              </div>

              <div
                class="col-lg-4 order-lg-3 text-lg-right align-self-lg-center"
              >
                <div class="card-profile-actions py-4 mt-lg-0">
                  <!--<base-button type="info" size="sm" class="mr-4"-->
                    <!--&gt;Connect</base-button-->
                  <!--&gt;-->
                  <!--<base-button type="default" size="sm" class="float-right"-->
                    <!--&gt;Message</base-button-->
                  <!--&gt;-->
                </div>
              </div>
              <div class="col-lg-4 order-lg-1">
                <div class="card-profile-stats d-flex justify-content-center">
                  <div>
                    <span class="heading">0</span>
                    <span class="description">{{translate(getLanguage(), "Amigos")}}</span>
                  </div>
                  <div>
                    <span class="heading">0</span>
                    <span class="description">{{translate(getLanguage(), "Problemas Resolvidos")}}</span>
                  </div>
                  <div>
                    <span class="heading">0</span>
                    <span class="description">{{translate(getLanguage(), "Cursos Completados")}}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="row justify-content-center">
              <div class="col-lg-9">
                <div class="text-center mt-5">
                  <h2 class="text-center">
                    {{translate(getLanguage(), "Informações Básicas")}}
                    <base-button size="sm" v-b-modal.modalbasicinfo><i class="fa fa-edit"></i></base-button>
                  </h2>
                  
                  <div class="h6 font-weight-300">
                    <i class="fa fa-map-marker"></i> {{cityAddress}} - {{stateAddress}}, {{countryAddress}}
                  </div>
                  <div class="h6">
                    <i class="fa fa-briefcase"></i> {{currentPosition}} {{translate(getLanguage(), "em")}} <strong>{{currentEmployer}}</strong>
                  </div>
                  <div class="h6">
                    <i class="fa fa-graduation-cap"></i> {{degreeLevel}} {{translate(getLanguage(), "em")}} <strong>{{degreeInstitution}}</strong>
                  </div>
                  <div class="progressCompletion">
                    <h5 class="text-sm-left">
                      {{translate(getLanguage(), "Progresso de Conclusão")}}<small>- {{ translate(getLanguage(), profileCompletionDescription()) }}</small>
                    </h5>
                    
                  </div>
                  <b-progress :value="progressBarValue" :max="progressBarMax" :variant="progressBarVariant()" height="1.2rem" show-value animated>
                    <b-progress-bar :value="progressBarValue">
                      <span>{{translate(getLanguage(), "Progresso")}}: <strong>{{ 100*(progressBarValue/ progressBarMax) }}%</strong></span>
                    </b-progress-bar>
                  </b-progress>
                </div>
              </div>
            </div>
            <div class="mt-5 pt-5 border-top text-center">
              <div class="row justify-content-center">
                <div class="col-lg-9">
                    <h2 class="text-sm-left">
                      {{translate(getLanguage(), "Resumo")}}
                      <base-button size="sm" v-b-modal.modalsummaryinfo variant="light"><i class="fa fa-edit"></i></base-button>
                    </h2>
                    <div class="spacer"></div>
                  
                  <p class="text-sm-left">
                    {{summary}}
                  </p>
                </div>
              </div>
            </div>
            <div class="mt-5 pt-5 border-top text-center">
              <div class="row justify-content-center">
                <div class="col-lg-9">
                    <h2 class="text-sm-left">
                      {{translate(getLanguage(), "Informações Pessoais")}}
                      <base-button size="sm" v-b-modal.modalpersonalinfo variant="light" class="right"><i class="fa fa-edit"></i></base-button>
                    </h2>
                    
                  <div class="h6 text-sm-left  font-weight-300">
                    <i class="fa fa-envelope mr-1">
                      
                    </i> Email: {{email}}
                  </div>
                  <div class="h6 text-sm-left  font-weight-300">
                    <i class="fa fa-phone-square mr-1">
                      
                    </i> {{translate(getLanguage(), "Telefone")}}: {{phone}}
                  </div>
                  <div class="h6 text-sm-left  font-weight-300">
                    <i class="fa fa-linkedin-square mr-1">
                      
                    </i> LinkedIn: {{linkedin}}
                  </div>
                  <div class="h6 text-sm-left  font-weight-300">
                    <i class="fa fa-github-square mr-1">
                      
                    </i> GitHub: {{github}}
                  </div>
                  <div class="h6 text-sm-left  font-weight-300">
                    <i class="fa fa-user-circle mr-1">
                      
                    </i> {{translate(getLanguage(), "Site Pessoal")}}: {{website}}
                  </div>
                </div>
              </div>
            </div>
            <div class="mt-5 py-5 border-top text-center">
              <div class="row justify-content-center">
                <div class="col-lg-9">
                  <h2 class="text-sm-left">
                    {{translate(getLanguage(), "Experiência")}}
                    <base-button size="sm" v-b-modal.modalexperienceinfo variant="light" class="right"><i class="fa fa-edit"></i></base-button>
                  </h2>
                  
                  <p class="text-sm-left">
                    {{translate(getLanguage(), "Anos de Experiência")}}: {{yearsOfExperience}}
                  </p>
                  <div class="col-lg-3 left skills">
                  <p class="text-sm-left">
                    {{translate(getLanguage(), "Habilidades")}}: <base-alert v-for="(skill, index) in skills" :key="index">{{skill}}</base-alert>
                  </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </card>
      </div>
    </section>

    <div class="container shape-container d-flex">
      <div class="col mt-4">
        <div class="row justify-content-center px-50">
          <router-link to="/report">
            <base-button type="info" size="lg" class="align-center">
              <div class="px-5">
                <i style="color: white" class="fa fa-check-circle"></i>
                <span class="btn-inner--text">{{translate(getLanguage(), "Veja seu ultimo resultado")}}</span>
              </div>
            </base-button >
          </router-link>
        </div>
      </div>
    </div>


    <b-modal id="modalbasicinfo" centered :title="getBasicInfoTitle()">
      <p>{{translate(getLanguage(), "Nome")}}</p>
      <base-input id="name" v-model="name"></base-input>
      <p>{{translate(getLanguage(), "Localização")}}</p>
      <div class="container">
        <div class="row row-grid align-items-left">
          <div class="col-lg-4">
            <base-input id="city" v-model="cityAddress"></base-input>
          </div>
          <div class="col-lg-4">
            <base-input id="state" v-model="stateAddress"></base-input>
          </div>
          <div class="col-lg-4">
            <base-input id="country" v-model="countryAddress"></base-input>
          </div>
        </div>
      </div>
      <p>{{translate(getLanguage(), "Emprego Atual")}}</p>
      <div class="container">
        <div class="row row-grid left">
          <div class="col-lg-4">
            <base-input id="current-position" v-model="currentPosition"></base-input>
          </div>
          <div class="align-middle">
            {{translate(getLanguage(), "em")}}
          </div>
          <div class="col-lg-4">
            <base-input id="current-employer" v-model="currentEmployer"></base-input>
          </div>
        </div>
      </div>
      <p>{{translate(getLanguage(), "Formação")}}</p>
      <div class="container">
        <div class="row row-grid align-items-left">
          <div class="col-lg-4">
            <base-input id="education-level" v-model="degreeLevel"></base-input>
          </div>
          <div class="align-middle">
            {{translate(getLanguage(), "em")}}
          </div>
          <div class="col-lg-4">
            <base-input id="education-institution" v-model="degreeInstitution"></base-input>
          </div>
        </div>
      </div>
      <template v-slot:modal-footer="{ ok, cancel }">
        <!-- Emulate built in modal footer ok and cancel button actions -->
        <b-button size="md" variant="success" @click="updateUserBasicInfo(); ok()">
          {{translate(getLanguage(), "SALVAR")}}
        </b-button>
        <b-button size="md" variant="secondary" @click="restoreUser(); cancel();">
          {{translate(getLanguage(), "CANCELAR")}}
        </b-button>
      </template>
    </b-modal>

    <b-modal id="modalpersonalinfo" centered :title="getPersonalInfoTitle()">
      <p>Email</p>
      <base-input id="email" v-model="email"></base-input>
      <p>{{translate(getLanguage(), "Telefone")}}</p>
      <base-input id="phone" v-model="phone"></base-input>
      <p>LinkedIn</p>
      <base-input id="linkedin" v-model="linkedin"></base-input>
      <p>GitHub</p>
      <base-input id="github" v-model="github"></base-input>
      <p>WebSite</p>
      <base-input id="website" v-model="website"></base-input>
      <template v-slot:modal-footer="{ ok, cancel }">
        <!-- Emulate built in modal footer ok and cancel button actions -->
        <b-button size="md" variant="success" @click="updateUserPersonalInfo(), ok()">
          {{translate(getLanguage(), "SALVAR")}}
        </b-button>
        <b-button size="md" variant="secondary" @click="restoreUser(); cancel();">
          {{translate(getLanguage(), "CANCELAR")}}
        </b-button>
      </template>
    </b-modal>

    <b-modal id="modalsummaryinfo" centered :title="getSummaryTitle()">
      <base-input id="summary" v-model="summary"></base-input>
      <template v-slot:modal-footer="{ ok, cancel }">
        <!-- Emulate built in modal footer ok and cancel button actions -->
        <b-button size="md" variant="success" @click="updateUserSummary(); ok()">
          {{translate(getLanguage(), "SALVAR")}}
        </b-button>
        <b-button size="md" variant="secondary" @click="restoreUser(); cancel();">
          {{translate(getLanguage(), "CANCELAR")}}
        </b-button>
      </template>
    </b-modal>

    <b-modal id="modalexperienceinfo" centered :title="getExperienceTitle()">
      <p>{{translate(getLanguage(), "Anos de Experiência")}} </p>
      <base-input id="yearsOfExperience" v-model.number="yearsOfExperience" type="number" @keypress="preventNonNumber($event)"></base-input>
     
      <p class="text-sm-left">
        {{translate(getLanguage(), "Habilidades")}} ({{translate(getLanguage(), "Clique para remover")}}): <base-button type="button" v-for="(skill, index) in skills.concat(skillsUnsaved)" :key="index" @click="removeSkill(skill)">{{skill}}</base-button>
      </p>
      <div class="flex">
        <base-input value="NodeJs" v-model="skillAux"></base-input> 
        <b-button class="addbtn" size="md" variant="success" @click="addSkill()">+</b-button>
      </div>
      
      <template v-slot:modal-footer="{ ok, cancel }">
        <!-- Emulate built in modal footer ok and cancel button actions -->
        <b-button size="md" variant="success" @click="updateUserExperienceInfo(); ok()">
          {{translate(getLanguage(), "SALVAR")}}
        </b-button>
        <b-button size="md" variant="secondary" @click="restoreUser(); cancel();">
          {{translate(getLanguage(), "CANCELAR")}}
        </b-button>
      </template>
    </b-modal>
  </div>

</template>
<script>
import translate from "../i18n/i18n.js";
export default {
  components: {},

  data: () => ({
      name: "name",
      email: "youremail@example.com",
      skills: [
          "C++",
          "Python",
          "NodeJs"
      ],
      yearsOfExperience: 0,
      phone: "99999-9999",
      linkedin: "linkedin.com",
      github: "github.com",
      website: "carabom.com.br",

      cityAddress: '',
      stateAddress: '',
      countryAddress: '',
      currentPosition: '',
      currentEmployer: '',
      degreeLevel: '',
      degreeInstitution: '',
      
      summary: '',

      skillsUnsaved: [],
      skillAux: '',
      progressBarValue: 45,
      progressBarMax: 100
  }),
  computed: {
      
  },
  created: async function () {
    this.restoreUser();
  },
  methods: {
    getLanguage(){
      return localStorage.getItem('language') || 0;
    },
    translate: function(language, phrase){
      return translate(language, phrase);
    },
    preventNonNumber(evt) {
      evt = (evt) ? evt : window.event;
      const charCode = (evt.which) ? evt.which : evt.keyCode;
      if((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault();
        return false;
      }
      return true;
    },
    user: function() {
        return this.$store.getters.user
    },
    addSkill() {
      const skillToAdd = this.skillAux;
      this.skillAux = "";

      if(!skillToAdd) {
        // console.log('no skill to add');
        return;
      }

      if(this.skills.indexOf(skillToAdd) >= 0) {
        // console.log(skillToAdd + ' already in skills');
        return;
      }

      if(this.skillsUnsaved.indexOf(skillToAdd) >= 0) {
        // console.log(skillToAdd + ' already in skillsUnsaved');
        return;
      }

      this.skillsUnsaved.push(skillToAdd);
    },
    removeSkill(skillToRemove){
      console.log(skillToRemove + ' to remove');
      if(this.skills.indexOf(skillToRemove) >= 0) {
        console.log(skillToRemove + ' removed from skills');
        this.skills.splice(this.skills.indexOf(skillToRemove), 1);
      }
      if(this.skillsUnsaved.indexOf(skillToRemove) >= 0) {
        console.log(skillToRemove + ' removed from skill unsaved');
        this.skillsUnsaved.splice(this.skillsUnsaved.indexOf(skillToRemove), 1);
      }
      console.log(this.skills);
      console.log(this.skillsUnsaved);
    },
    restoreUser() {
        this.skillsUnsaved = [];
        this.skillAux = "";

        const userData = this.$store.getters.user;
        this.name = userData.Name;
        this.email = userData.Email;

        this.cityAddress = (userData.City !== "" && userData.City !== undefined ) ? userData.City : this.translate(this.getLanguage(), "Cidade");
        this.stateAddress = (userData.State !== "" && userData.State !== undefined ) ? userData.State : this.translate(this.getLanguage(), "Estado");
        this.countryAddress = (userData.Country !== "" && userData.Country !== undefined ) ? userData.Country : this.translate(this.getLanguage(), "País");

        this.currentPosition = (userData.CurrentJobPosition !== "" && userData.CurrentJobPosition !== undefined ) ? userData.CurrentJobPosition : this.translate(this.getLanguage(), "Cargo");
        this.currentEmployer = (userData.CurrentCompany !== "" && userData.CurrentCompany !== undefined ) ? userData.CurrentCompany : this.translate(this.getLanguage(), "Empresa");

        this.degreeLevel = (userData.DegreeLevel !== "" && userData.DegreeLevel !== undefined ) ? userData.DegreeLevel : this.translate(this.getLanguage(), "Curso");
        this.degreeInstitution = (userData.DegreeInstitution !== "" && userData.DegreeInstitution !== undefined ) ? userData.DegreeInstitution : this.translate(this.getLanguage(), "Instituição");
        
        this.phone = (userData.PhoneNumber !== "" && userData.PhoneNumber !== undefined ) ? userData.PhoneNumber : this.translate(this.getLanguage(), "Telefone");
        this.linkedin = (userData.LinkedInUrl !== "" && userData.LinkedInUrl !== undefined ) ? userData.LinkedInUrl : "LinkedIn Profile";
        this.github = (userData.GitHubUrl !== "" && userData.GitHubUrl !== undefined ) ? userData.GitHubUrl : "GitHub Profile";
        this.website = (userData.PersonalWebsiteUrl !== "" && userData.PersonalWebsiteUrl !== undefined ) ? userData.PersonalWebsiteUrl : this.translate(this.getLanguage(), "Site Pessoal");
        
        this.summary = (userData.Summary !== "" && userData.Summary !== undefined ) ? userData.Summary : this.translate(this.getLanguage(), "Aqui vai uma curta descrição sua e de seus interesses");
        
        this.yearsOfExperience = userData?.YearsOfExperience ?? 0;
        this.skills = userData.Skills !== undefined ? userData.Skills : [];
        this.updateProgressBar();
    },
    updateUserBasicInfo() {
        const userData = this.$store.getters.user;
        userData.Name = this.name;
        userData.City = this.cityAddress;
        userData.State = this.stateAddress;
        userData.Country = this.countryAddress;
        userData.CurrentJobPosition = this.currentPosition;
        userData.CurrentCompany = this.currentEmployer;
        userData.DegreeLevel = this.degreeLevel;
        userData.DegreeInstitution = this.degreeInstitution;
        this.$store.dispatch('setUser', userData);
        
        let userBasicInfo = {
            Name: this.name,   
            City: this.cityAddress,
            State: this.stateAddress,
            Country: this.countryAddress,
            CurrentJobPosition: this.currentPosition,
            CurrentCompany: this.currentEmployer,
            DegreeLevel: this.degreeLevel,
            DegreeInstitution: this.degreeInstitution,
        };

        const url = process.env.VUE_APP_API_URL + "/auth/user/" + this.$store.getters.user.id + "/basic-info";
        console.log('fetch=',url);
        fetch(url, {
            method: "PUT", // *GET, POST, PUT, DELETE, etc.
            mode: "cors", // no-cors, cors, *same-origin
            cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
            credentials: "same-origin", // include, *same-origin, omit
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + this.$store.getters.token
            },
            body: JSON.stringify(userBasicInfo) // body data type must match "Content-Type" header
        })
        this.updateProgressBar();
    },

    updateUserPersonalInfo() {
        const userData = this.$store.getters.user;
        userData.Email = this.email;
        userData.PhoneNumber = this.phone;
        userData.LinkedInUrl = this.linkedin;
        userData.GitHubUrl = this.github;
        userData.PersonalWebsiteUrl = this.website;
        this.$store.dispatch('setUser', userData);

        let userPersonalInfo = {
            Email: this.email,
            PhoneNumber: this.phone,
            LinkedInUrl: this.linkedin,
            GitHubUrl: this.github,
            PersonalWebsiteUrl: this.website,
        };

        const url = process.env.VUE_APP_API_URL + "/auth/user/" + this.$store.getters.user.id + "/personal-info";
        console.log('fetch=',url);
        fetch(url, {
            method: "PUT", // *GET, POST, PUT, DELETE, etc.
            mode: "cors", // no-cors, cors, *same-origin
            cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
            credentials: "same-origin", // include, *same-origin, omit
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + this.$store.getters.token
            },
            body: JSON.stringify(userPersonalInfo) // body data type must match "Content-Type" header
        })
        this.updateProgressBar();
    },

    updateUserSummary() {
        const userData = this.$store.getters.user;
        userData.Summary = this.summary;
        this.$store.dispatch('setUser', userData);

        let userSummary = {
            Summary: this.summary,
        };

        const url = process.env.VUE_APP_API_URL + "/auth/user/" + this.$store.getters.user.id + "/summary";
        console.log('fetch=',url);
        fetch(url, {
            method: "PUT", // *GET, POST, PUT, DELETE, etc.
            mode: "cors", // no-cors, cors, *same-origin
            cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
            credentials: "same-origin", // include, *same-origin, omit
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + this.$store.getters.token
            },
            body: JSON.stringify(userSummary) // body data type must match "Content-Type" header
        })
        this.updateProgressBar();
    },

    updateUserExperienceInfo() {
        const allSkills = [
          ...new Set(this.skills.concat(this.skillsUnsaved))
        ];


        const userData = this.$store.getters.user;
        userData.YearsOfExperience = this.yearsOfExperience;
        userData.Skills = allSkills;
        this.$store.dispatch('setUser', userData);

        let userExperienceInfo = {
            YearsOfExperience: this.yearsOfExperience,
            Skills: allSkills,
        };
        console.log('updateUserExperienceInfo:');
        console.log(userExperienceInfo);

        this.skills = allSkills;
        this.skillsUnsaved = [];
        this.skillsAux = "";

        const url = process.env.VUE_APP_API_URL + "/auth/user/" + this.$store.getters.user.id + "/experience-info";
        console.log('fetch=',url);
        fetch(url, {
            method: "PUT", // *GET, POST, PUT, DELETE, etc.
            mode: "cors", // no-cors, cors, *same-origin
            cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
            credentials: "same-origin", // include, *same-origin, omit
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + this.$store.getters.token
            },
            body: JSON.stringify(userExperienceInfo) // body data type must match "Content-Type" header
        })
        this.updateProgressBar();
    },
    updateProgressBar(){
      const userData = this.$store.getters.user;
      let progress = 0;
      progress += (userData.Name !== "" && userData.Name !== "" && userData.Name !== undefined ) ? 1 : 0;
      progress += (userData.Email !== "" && userData.Email !== "" && userData.Email !== undefined ) ? 1 : 0;

      progress += (userData.City !== this.translate(this.getLanguage(), "Cidade") && userData.City !== "" && userData.City !== undefined ) ? 1 : 0;
      progress += (userData.State !== this.translate(this.getLanguage(), "Estado") && userData.State !== "" && userData.State !== undefined ) ? 1 : 0;
      progress += (userData.Country !== this.translate(this.getLanguage(), "País") && userData.Country !== "" && userData.Country !== undefined ) ? 1 : 0;

      progress += (userData.CurrentJobPosition !== this.translate(this.getLanguage(), "Cargo") && userData.CurrentJobPosition !== "" && userData.CurrentJobPosition !== undefined ) ? 1 : 0;
      progress += (userData.CurrentCompany !== this.translate(this.getLanguage(), "Empresa") && userData.CurrentCompany !== "" && userData.CurrentCompany !== undefined ) ? 1 : 0;

      progress += (userData.DegreeLevel !== this.translate(this.getLanguage(), "Curso") && userData.DegreeLevel !== "" && userData.DegreeLevel !== undefined ) ? 1 : 0;
      progress += (userData.DegreeInstitution !== this.translate(this.getLanguage(), "Instituição") && userData.DegreeInstitution !== "" && userData.DegreeInstitution !== undefined ) ? 1 : 0;
      
      progress += (userData.PhoneNumber !== this.translate(this.getLanguage(), "Telefone") && userData.PhoneNumber !== "" && userData.PhoneNumber !== undefined ) ? 1 : 0;
      progress += (userData.LinkedInUrl !== "LinkedIn Profile" && userData.LinkedInUrl !== "" && userData.LinkedInUrl !== undefined ) ? 1 : 0;
      progress += (userData.GitHubUrl !== "GitHub Profile" && userData.GitHubUrl !== "" && userData.GitHubUrl !== undefined ) ? 1 : 0;
      progress += (userData.PersonalWebsiteUrl !== this.translate(this.getLanguage(), "Site Pessoal") && userData.PersonalWebsiteUrl !== "" && userData.PersonalWebsiteUrl !== undefined ) ? 1 : 0;
      
      progress += (userData.Summary !== this.translate(this.getLanguage(), "Aqui vai uma curta descrição sua e de seus interesses") && userData.Summary !== "" && userData.Summary !== undefined ) ? 1 : 0;
      
      progress += userData.YearsOfExperience !== undefined ? 1 : 0;
      progress += (userData.Skills !== undefined && userData.Skills.length !== 0) ? 1 : 0;

      this.progressBarValue = progress;
      this.progressBarMax = 16; 
    },
    progressBarVariant(){
      return this.progressBarValue != this.progressBarMax ? "none" : "success";
    },
    profileCompletionDescription(){
      return this.progressBarValue != this.progressBarMax ? "Complete as informações para seu perfil aparecer pras empresas" :
      "Seu perfil está disponível para as empresas";
    },
    getBasicInfoTitle(){
      return this.translate(this.getLanguage(), "Informações Básicas");
    },
    getPersonalInfoTitle(){
      return this.translate(this.getLanguage(), "Informações Pessoais");
    },
    getSummaryTitle(){
      return this.translate(this.getLanguage(), "Resumo");
    },
    getExperienceTitle(){
      return this.translate(this.getLanguage(), "Experiência");
    }
  }
};
</script>

<style>
  .modal-backdrop{
    opacity: 0.3;
  }
  .skills{
    padding-left: 0px !important;
  }
  div.flex {
    display: flex;
  }
  .addbtn {
    height: auto !important;
    margin-left: 10px !important;
    margin-bottom: 1rem;
  }
  .progressCompletion {
    padding-top: 30px;
  }
</style>
